import React, { useState, useEffect } from 'react';
import TextInput from './TextInput';
import Button from './Button';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';

const EmailListInput = ({ label, name, value = [], onChange, fieldErrors, required = false }) => {
  const [emails, setEmails] = useState(value.length > 0 ? value : ['']);

  useEffect(() => {
    if (JSON.stringify(value) !== JSON.stringify(emails) && !(value.length === 0 && emails.length === 1 && emails[0] === '')) {
      setEmails(value.length > 0 ? value : ['']);
    }
  }, [value, emails]);

  const handleEmailChange = (index, e) => {
    const newEmails = [...emails];
    newEmails[index] = e.target.value;
    setEmails(newEmails);
    onChange({ target: { name, value: newEmails } });
  };

  const handleAddEmail = () => {
    const newEmails = [...emails, ''];
    setEmails(newEmails);
    onChange({ target: { name, value: newEmails } });
  };

  const handleRemoveEmail = (index) => {
    if (emails.length === 1 && emails[0] === '') {
      return;
    }
    const newEmails = emails.filter((_, i) => i !== index);

    if (newEmails.length === 0) {
      newEmails.push('');
    }
    setEmails(newEmails);
    onChange({ target: { name, value: newEmails } });
  };

  const generalError = fieldErrors && fieldErrors[name] ? fieldErrors[name][0] : undefined;

  return (
    <div className="mb-4">
      <label className="block text-text-gray text-sm font-bold mb-2">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      {emails.map((email, index) => (
        <div key={index} className="flex items-center mb-2">
          <TextInput
            name={`${name}[${index}]`}
            id={`${name}-${index}`}
            value={email}
            onChange={(e) => handleEmailChange(index, e)}
            placeholder={`Email ${index + 1}`}
            type="email"
            className="flex-1 mr-2"
            error={fieldErrors && fieldErrors[`${name}.${index}`] ? fieldErrors[`${name}.${index}`][0] : undefined}
          />
          {(emails.length > 1 || (emails.length === 1 && emails[0] !== '')) && (
            <Button
              type="button"
              onClick={() => handleRemoveEmail(index)}
              className="ml-4 bg-red-500 hover:bg-red-600 text-white px-3 py-2 rounded"
              icon={faMinus}
            />
          )}
        </div>
      ))}
      <Button
        type="button"
        onClick={handleAddEmail}
        className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-2 rounded mt-2"
        icon={faPlus}
      >
        Add More
      </Button>
      {generalError && <p className="text-red-500 text-xs italic mt-1">{generalError}</p>}
    </div>
  );
};

export default EmailListInput;